import React, { useCallback, useContext, useEffect, useState } from 'react';
import { IUser, IUseData } from '../constants/types';

export const DataContext = React.createContext({});

export const DataProvider = ({ children }: { children: React.ReactNode }) => {
  const [appIsReady, setAppIsReady] = useState(false);
  const [user, setUser] = useState<IUser>();

  // handle user
  const handleUser = useCallback(
    (payload: IUser) => {
      // set user / compare if has updated
      console.log('Handle User ======== ===========================');
      if (JSON.stringify(payload) !== JSON.stringify(user)) {
        setUser(payload);
      }
    },
    [user, setUser],
  );

  const logoutUser = useCallback(() => {
    setUser(undefined);
    localStorage.removeItem('user');
    localStorage.removeItem('access_token'); // 토큰도 제거
    localStorage.removeItem('token'); // 혹시 있을 수 있는 토큰도 제거
    console.log('로그아웃: 사용자 정보 및 토큰 제거 완료');
  }, [user, setUser]);

  const saveUser = useCallback(
    (value: IUser) => {
      console.log('saveUser=' + JSON.stringify(value));
      setUser(value);
      localStorage.setItem('user', JSON.stringify(value));

      // 토큰이 있는 경우 localStorage에 저장
      if (value && value.accessToken && typeof value.accessToken === 'string') {
        localStorage.setItem('access_token', value.accessToken);
        console.log(
          '✅ useData에서 토큰 저장:',
          value.accessToken.substring(0, 20) + '...',
        );
      }
    },
    [user, setUser],
  );

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    const storedToken = localStorage.getItem('access_token');

    if (storedUser) {
      setUser(JSON.parse(storedUser));
      console.log('✅ 저장된 사용자 정보 로드:', JSON.parse(storedUser).userid);
    }

    if (storedToken) {
      console.log('✅ 저장된 토큰 확인:', storedToken.substring(0, 20) + '...');
    } else {
      console.log('⚠️ 저장된 토큰이 없습니다.');
    }

    setAppIsReady(true);
  }, []);

  const contextValue = {
    appIsReady,
    setAppIsReady,
    saveUser,
    logoutUser,
    user,
    handleUser,
  };

  return (
    <DataContext.Provider value={contextValue}>{children}</DataContext.Provider>
  );
};

export const useData = () => useContext(DataContext) as IUseData;
